import * as React from 'react';
import { Introduction } from '../IntroductionRedesigned';
import { Responsive } from '@cian/ui-kit';
import { StickyBottomLayout } from '../../components/StickyBottomLayout';
import { MobileCall } from '../MobileCall';
import { FixedHeader } from '../FixedHeaderRedesign';
import { Facts } from '../Facts';
import { ContentWrapper } from '../../components/ContentWrapper/';
import { AboutContainer } from '../../components/AboutRedesigned';
import { Ratings, Awards } from '../Awards';
import { SpecialPromoRedesign } from '../SpecialPromoRedesign';
import { ProjectsRedesigned } from '../Projects';
import { ProjectsOnMap } from '../ProjectsOnMap';
import { ReliabilityContainer } from '../ReliabilityContainer';
import { Reviews } from '../Reviews';
import { MortgageCalculatorSection } from '../MortgageCalculatorSection';
import { Mortgage } from '../Mortgage';
import { Benefits } from '../Benefits';
import { News } from '../News';

export const PageFSK: React.FC = () => {
  return (
    <div data-testid="PageFSK">
      <Responsive desktop>
        <FixedHeader />
      </Responsive>
      <Introduction />
      <Facts />
      <ContentWrapper>
        <AboutContainer />
        <Responsive tablet phone>
          <ReliabilityContainer />
        </Responsive>
        <MortgageCalculatorSection />
        <SpecialPromoRedesign />
        <Ratings />
        <Awards />
        <ProjectsRedesigned />
        <ProjectsOnMap />
        <Reviews />
        <Mortgage />
        <Benefits />
        <News />
      </ContentWrapper>
      <Responsive tablet phone>
        <StickyBottomLayout>
          <MobileCall />
        </StickyBottomLayout>
      </Responsive>
    </div>
  );
};
